import MealsMealsChart from "@/components/statistics/meals/MealsMealsChart.vue";
import MealsShiftsChart from "@/components/statistics/meals/MealsShiftsChart.vue";
import MealsTakenChart from "@/components/statistics/meals/MealsTakenChart.vue";
import MealsCompaniesChart from "@/components/statistics/meals/MealsCompaniesChart.vue";
import GroupMealsMealsChart from "@/components/statistics/group-meals/GroupMealsMealsChart.vue";
import GroupMealsShiftsChart from "@/components/statistics/group-meals/GroupMealsShiftsChart.vue";
import GroupMealsDaysChart from "@/components/statistics/group-meals/GroupMealsDaysChart.vue";
import GroupMealsDaysMealsChart from "@/components/statistics/group-meals/GroupMealsDaysMealsChart.vue";
import GroupMealsCompaniesChart from "@/components/statistics/group-meals/GroupMealsCompaniesChart.vue";
import GroupMealsCategoriesChart from "@/components/statistics/group-meals/GroupMealsCategoriesChart.vue";
import MoreRestaurantsCompaniesChart from "@/components/statistics/more-restaurants/MoreRestaurantsCompaniesChart.vue";
import MoreRestaurantsShiftsChart from "@/components/statistics/more-restaurants/MoreRestaurantsShiftsChart.vue";
import MoreRestaurantsMealsChart from "@/components/statistics/more-restaurants/MoreRestaurantsMealsChart.vue";
import MoreRestaurantsTakenChart from "@/components/statistics/more-restaurants/MoreRestaurantsTakenChart.vue";
import { companyVariant } from "@/components/company-report/companyReportMenu";
import {
  StatsFeedCompanyDefault,
  StatsFeedCompanyGroup,
  StatsFeedGroupMeals,
  StatsFeedMeals,
  StatsFeedMoreRestaurants,
} from "./statsFeeds";

/** Tipovi naloga sa statistikom: restoran (admin, restoran, izveštaji) ili firma. */
export const RESTAURANT_TYPES = ["admin", "restaurant", "report"];
export const COMPANY_TYPES = ["company"];

/** Prikazi restorana (isti brojevi kao u /izvestaj). */
export const VIEW_MEALS = 1;
export const VIEW_GROUP = 2;
export const VIEW_MORE = 3;

/**
 * Vrsta statistike za korisnika: "restaurant" (tri prikaza), firma "company-default" / "company-group" /
 * "company-multi" (firma sa više restorana, za koju grafikoni još ne postoje) ili null (nalog bez statistike).
 */
export const statsKind = (userType, company) => {
  if (RESTAURANT_TYPES.includes(userType)) {
    return "restaurant";
  }
  if (COMPANY_TYPES.includes(userType)) {
    return `company-${{ plain: "default", group: "group", multi: "multi" }[companyVariant(company)]}`;
  }
  return null;
};

/**
 * Prikazi statistike i njihovi grafikoni: [{ id, name, feed, charts: { ključ: grafikon }, sections: [{ key, title, icon }] }].
 * `feed` učitava podatke (stari tab), a `charts` bira grafikon po odeljku. Prikaz bez `feed` još nema grafikone.
 */
export const buildStatsViews = (t, kind) => {
  if (kind === "restaurant") {
    return [
      {
        id: VIEW_MEALS,
        name: t("meal_in_meals"),
        feed: StatsFeedMeals,
        charts: { meals: MealsMealsChart, shifts: MealsShiftsChart, taken: MealsTakenChart, companies: MealsCompaniesChart },
        sections: [
          { key: "meals", title: t("meal_in_meals"), icon: "mdi-food" },
          { key: "shifts", title: t("orders_by_shift"), icon: "mdi-clock-time-four-outline" },
          { key: "taken", title: t("ordered_taken_meals"), icon: "mdi-check-circle-outline" },
          { key: "companies", title: t("companies"), icon: "mdi-office-building" },
        ],
      },
      {
        id: VIEW_GROUP,
        name: t("meal_in_groops"),
        feed: StatsFeedGroupMeals,
        charts: {
          meals: GroupMealsMealsChart,
          shifts: GroupMealsShiftsChart,
          days: GroupMealsDaysChart,
          daysMeals: GroupMealsDaysMealsChart,
          companies: GroupMealsCompaniesChart,
        },
        sections: [
          { key: "meals", title: t("routes.jela"), icon: "mdi-food-drumstick" },
          { key: "shifts", title: t("orders_by_shift"), icon: "mdi-clock-time-four-outline" },
          { key: "days", title: t("daily"), icon: "mdi-calendar-range" },
          { key: "daysMeals", title: `${t("routes.jela")} / ${t("daily")}`, icon: "mdi-food-drumstick-outline" },
          { key: "companies", title: t("companies"), icon: "mdi-office-building" },
        ],
      },
      {
        id: VIEW_MORE,
        name: t("companies_fed_by_restaurant"),
        feed: StatsFeedMoreRestaurants,
        charts: {
          companies: MoreRestaurantsCompaniesChart,
          shifts: MoreRestaurantsShiftsChart,
          meals: MoreRestaurantsMealsChart,
          taken: MoreRestaurantsTakenChart,
        },
        sections: [
          { key: "companies", title: t("companies"), icon: "mdi-office-building" },
          { key: "shifts", title: t("orders_by_shift"), icon: "mdi-clock-time-four-outline" },
          { key: "meals", title: t("meals"), icon: "mdi-food" },
          { key: "taken", title: t("ordered_taken_meals"), icon: "mdi-check-circle-outline" },
        ],
      },
    ];
  }
  if (kind === "company-default") {
    return [
      {
        id: 1,
        name: t("routes.statistics"),
        feed: StatsFeedCompanyDefault,
        charts: { meals: MealsMealsChart, shifts: MealsShiftsChart, taken: MealsTakenChart, branches: MealsCompaniesChart },
        sections: [
          { key: "meals", title: t("meal_in_meals"), icon: "mdi-food" },
          { key: "shifts", title: t("orders_by_shift"), icon: "mdi-clock-time-four-outline" },
          { key: "taken", title: t("ordered_taken_meals"), icon: "mdi-check-circle-outline" },
          { key: "branches", title: t("branches"), icon: "mdi-store" },
        ],
      },
    ];
  }
  if (kind === "company-group") {
    return [
      {
        id: 1,
        name: t("routes.statistics"),
        feed: StatsFeedCompanyGroup,
        charts: { meals: GroupMealsMealsChart, shifts: GroupMealsShiftsChart, days: GroupMealsDaysChart, categories: GroupMealsCategoriesChart },
        sections: [
          { key: "meals", title: t("meal_in_meals"), icon: "mdi-food-drumstick" },
          { key: "shifts", title: t("orders_by_shift"), icon: "mdi-clock-time-four-outline" },
          { key: "days", title: t("daily"), icon: "mdi-calendar-range" },
          { key: "categories", title: t("groups_meal"), icon: "mdi-shape" },
        ],
      },
    ];
  }
  if (kind === "company-multi") {
    return [
      {
        id: 1,
        name: t("routes.statistics"),
        feed: null,
        charts: {},
        sections: [{ key: "overview", title: t("routes.statistics"), icon: "mdi-sitemap-outline" }],
      },
    ];
  }
  return [];
};
